import request from "./request";
import UnionAxios from "../utils/union-axios";

/**
 * 业务请求测试
 */
export const postCancel = () => {
  return request(`/web-h5/charge/conversion/cancel`, {}, "POST");
};
/**
 * 查询VIP卡券获得记录
 */
export function GetQueryMyGoodsRecord() {
  return request(
    `/web-h5/charge/member/queryMyGoodsRecord`,
    { uid: "" },
    "POST",
  );
}
/**
 * 获取用户信息
 */
export const getUserInfo = () => {
  return UnionAxios.get(`/web-h5/charge/member/getCurrentUserInfo`);
};

/**
 * 获取当前用户积分余额
 */
export function GetUserCredit() {
  return request(`/web-h5/charge/getUserCredit`, {}, "GET");
}

function getCookie(name) {
  const cookieString = document.cookie;
  const cookies = cookieString.split("; ");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].split("=");
    if (cookie[0] === name) {
      return decodeURIComponent(cookie[1]);
    }
  }
  return null;
}
/**
 * uid获取通用方法
 * 在普通浏览器端static域名拿不到chargegateway域名的cookie，即无法获取到uid
 * 这里做一个特殊处理，若在APP/小程序环境内，拿联登sdk处理时传入的preUid作为当前用户uid，在普通浏览器内使用接口获取uid
 */
export const getCurrentUid = () => {
  return new Promise<string>((resolve) => {
    const sessionUid =
      sessionStorage.getItem("sessionUid") ||
      getCookie("xp-uid") ||
      getCookie("wasxuid_r") ||
      "";
    if (sessionUid) {
      resolve(sessionUid);
    } else {
      getUserInfo()
        .then((res) => {
          if (res.code === 200) {
            const uid = res.data.uid || "";
            sessionStorage.setItem("sessionUid", uid);
            resolve(uid);
          } else {
            resolve("");
          }
        })
        .catch(() => {
          resolve("");
        });
    }
  });
};
